<div class="row mr-0">
	<div #heroBanner id="hero-container" class="col-12 hero-container px-0">
		<img class="w-100 d-block banner" src="{{seriesView && heroWeb ? heroWeb : heroWebImage}}"
			alt="Hero Image" />
		<div class="gradient"></div>

		<div class="hero-overlay col-12" [class.series-view-v2-overlay]="seriesView">
			<img *ngIf="newVideo" class="thumb-new mb-2" src="assets/new.svg" height="30px" alt="New Video" />
			<img *ngIf="!seriesView && media.channelImageUrl" class="channelImage d-block d-lg-block"
				src="{{media.channelImageUrl}}" alt="Channel Logo" /> <!-- TODO: ACCESIBILITY -->
			<img *ngIf="seriesView && logo" class="channelImage d-block ml-5" src="{{logo}}" alt="Channel Logo" />
			<h4 class="text-white mt-4" *ngIf="!seriesView" [class.series-view-v2-text]="seriesView">{{media.title}}
			</h4>
		</div>
	</div>
</div>
